<template>
	<section class="section explore" v-if="results">

		<input class="tabs-input" checked="checked" id="tab1" type="radio" name="explore" />
		<input class="tabs-input" id="tab2" type="radio" name="explore" />
		<input class="tabs-input" id="tab3" type="radio" name="explore" />

		<h3 class="explore__mobile-title">Explore by</h3>

		<nav class="tabs-nav">
			<ul>
				<li class="tab1">
					<label for="tab1">Type</label>
				</li>
				<li class="tab2">
					<label for="tab2">Escape factor</label>
				</li>
				<li class="tab3">
					<label for="tab3">Work area</label>
				</li>
			</ul>
		</nav>

		<div class="tabs">
			<div class="tab1 explore-by explore-by-type">
				<h4 class="explore-by__title">Explore by <span>type</span></h4>
				<div class="explore-by__cards">
					<template v-for="(item,index) in results['option-listing-type']" :key="index">
						<div class="explore-by__card">
							<a :href="calculated_link('option-listing-type',item.title)">
								<div class="explore-by__card-img">
									<img :src="item.image" alt="Explore by type" loading="lazy">
								</div>
								<div class="explore-by__card-body">
									<h5 class="explore-by__card-body__title">{{ item.title }}</h5>
									<p class="explore-by__card-body__text">({{ item.count }})</p>
								</div>
							</a>
						</div>
					</template>

				</div>
			</div>

			<div class="tab2 explore-by explore-by-escape-factor">
				<h4 class="explore-by__title">Explore by <span>escape factor</span></h4>
				<div class="explore-by__cards">
					<template v-for="(item,index) in results['option-esc-factor']" :key="index">
						<div class="explore-by__card">
							<a :href="calculated_link('option-esc-factor',item.title)">
								<div class="explore-by__card-img">
									<img :src="item.image" alt="Explore by escape factor" loading="lazy">
								</div>
								<div class="explore-by__card-body">
									<h5 class="explore-by__card-body__title">{{ item.title }}</h5>
									<p class="explore-by__card-body__text">({{ item.count }})</p>
								</div>
							</a>
						</div>
					</template>
				</div>
			</div>

			<div class="tab3 explore-by explore-by-work-area">
				<h4 class="explore-by__title">Explore by <span>work area</span></h4>
				<div class="explore-by__cards">
					<template v-for="(item,index) in results['option-work-area']" :key="index">
						<div class="explore-by__card">
							<a :href="calculated_link('option-work-area',item.title)">
								<div class="explore-by__card-img">
									<img :src="item.image" alt="Explore by work area" loading="lazy">
								</div>
								<div class="explore-by__card-body">
									<h5 class="explore-by__card-body__title">{{ item.title }}</h5>
									<p class="explore-by__card-body__text">({{ item.count }})</p>
								</div>
							</a>
						</div>
					</template>
				</div>
			</div>

		</div>
	</section>

</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		components: {

		},
		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'listings-test' : 'listings-live',
				searchObject: {
					hitsPerPage: 1,
					facets: ["option-listing-type","option-esc-factor","option-work-area"],
					facetFilters: [["published:true"]],
					sortFacetValuesBy: 'count'
				},
				results: false,
				sequence_count: 0
			}
		},
		methods: {
			calculated_image() {
				return '/images/icons/explore/icon-'+this.icon_num+'.png?'+this.$config.version;
			},
			calculated_link(facet_name,term) {
				let query = facet_name+"="+term.replace("&","~").replace("%","¶");
				return '/search/jobs?q='+encodeURIComponent(query);
			}
		},
		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);


			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("explore search raw results:", results);
					if (results.nbHits > 0) {
						let icon_num = 0;
						this.results = {};
						for (const [fg_key, facet_group] of Object.entries(results.facets)) {
							console.log({facet_group});
							this.results[fg_key] = [];
							for (const [f_key, facet] of Object.entries(facet_group)) {
								icon_num++;
								this.results[fg_key].push({'count':facet, 'title':f_key, 'image':'/images/icons/explore/icon-'+((icon_num % 6)+1)+'.png'});
							}
						};
						console.log("results",this.results);
					} else {
						this.results = false;
					}
				});
		},
		computed: {
			icon_num() {
				this.sequence_count++;
				if (this.sequence_count == 7) {
					this.sequence_count = 1;
				}
				return this.sequence_count;
			}
		}
	}
</script>
